import { FC, ReactNode, useState } from 'react'
import styled from 'styled-components'
import { Dialog } from './Dialog'
import { Header } from './Header'

type LayoutProps = {
  children: ReactNode
}

export const Layout: FC<LayoutProps> = (props) => {
  const { children } = props
  const [isShowDialog, setIsShowDialog] = useState(false)

  return (
    <>
      <Header onClickReloadButton={() => setIsShowDialog(true)} />
      <StyledMain>{children}</StyledMain>

      <Dialog
        title="申請をはじめからやり直しますか？"
        isShow={isShowDialog}
        onClose={() => setIsShowDialog(false)}
        submitButtonTitle="やり直す"
        onSubmit={() => {
          location.href = '/'
        }}
      >
        これまでのすべての回答がクリアされ、
        <br />
        最初から再開されます。
      </Dialog>
      <NoticeYearEndHoliday />
    </>
  )
}

const StyledMain = styled.main`
  position: relative;
  display: flex;
  flex-direction: column;
  background: rgb(255, 255, 255);
  max-width: 1024px;
  min-height: 100%;
  margin: 0px auto;
  padding-top: 60px;
  overflow: hidden;
`

// TODO: 年末年始終わたら消す
const NoticeYearEndHolidayComponent = styled.div`
  position: sticky;
  bottom: 16px;
  background: #3e9f26;
  color: white;
  padding: 8px 16px;
  text-align: center;
  border-radius: 8px;
  margin: 16px 16px 8px;
  border: 2px solid white;
`

const NoticeYearEndHoliday = () => {
  if (!(new Date() < new Date('2024-01-04'))) {
    return null
  }

  return (
    <NoticeYearEndHolidayComponent>
      年末年始休業のお知らせ: 2023年12月29日〜2023年1月3日まで休業となります
    </NoticeYearEndHolidayComponent>
  )
}
